import { ethers } from "ethers";
import { EVM_CONFIG } from "../config";
import type { PoseidonFunction } from "circomlibjs";

export const FIELD_PRIME = BigInt(
  "21888242871839275222246405745257275088548364400416034343698204186575808495617",
);
const ABI_CODER = ethers.AbiCoder.defaultAbiCoder();

let poseidonPromise: Promise<PoseidonFunction> | null = null;

async function getPoseidon(): Promise<PoseidonFunction> {
  if (!poseidonPromise) {
    poseidonPromise = import("circomlibjs").then((lib) => lib.buildPoseidon());
  }
  return poseidonPromise;
}

async function deriveLegacyFungibleTokenHash(
  tokenAddress: string,
): Promise<bigint> {
  const poseidon = await getPoseidon();
  const hash = poseidon([BigInt(ethers.getAddress(tokenAddress))]);
  return BigInt(poseidon.F.toObject(hash).toString()) % FIELD_PRIME;
}

function derivePoolBoundTokenHash(
  tokenAddress: string,
  tokenType: number,
  tokenSubID: string,
): bigint {
  const digest = ethers.keccak256(
    ABI_CODER.encode(
      ["string", "uint256", "address", "address", "uint8", "uint256"],
      [
        "STEALTHOS_EVM_TOKEN_HASH_V3",
        BigInt(EVM_CONFIG.CHAIN_ID),
        ethers.getAddress(EVM_CONFIG.CONTRACTS.SHIELDED_POOL_NOVA),
        ethers.getAddress(tokenAddress),
        tokenType,
        BigInt(tokenSubID),
      ],
    ),
  );
  return BigInt(digest) % FIELD_PRIME;
}

export async function deriveBaseTokenHash(
  tokenAddress: string,
  tokenType: number,
  tokenSubID: string,
): Promise<bigint> {
  const isFungible = tokenType === 0 && BigInt(tokenSubID) === 0n;
  if (isFungible && EVM_CONFIG.FUNGIBLE_TOKEN_HASH_MODE === "legacy_poseidon") {
    return deriveLegacyFungibleTokenHash(tokenAddress);
  }
  return derivePoolBoundTokenHash(tokenAddress, tokenType, tokenSubID);
}
